import { Page } from '../Page';

export function SurveyPage() {
  return (
    <Page className="container mb-5" title="Collectible Stories" introBg hideNavbar hideFooter>
      <iframe id="waitlist-survey" src="https://gemzfun.typeform.com/to/xRS5EBgJ"></iframe>
    </Page>
  );
}
